<template>
  <div v-if="true">
    <div class="row">
      <b-button
        @click="nuevoContenido"
        class="ml-2 btn-pill"
        size="sm"
        variant="primary"
        :disabled="kilogramDiference.value() <= 0"
      >
        <i class="fa fa-plus"></i> Agregar contenido
      </b-button>

      <b-button
        v-b-modal.modal-lots
        class="ml-2 btn-pill"
        size="sm"
        variant="secondary"
      >
        <i class="fa fa-search"></i> Lotes procesados
      </b-button>

      <b-button
        @click="openModalMerma"
        class="ml-2 btn-pill"
        size="sm"
        variant="primary"
      >
        Cuadrar proceso
      </b-button>
    </div>

    <hr />

    <b-modal size="sm" v-model="modalMerma" title="Cuadrar Proceso">
      <div class="text-center">
        <b-alert show> <h4>¿Quieres cuadrar el proceso?</h4></b-alert>

        <p>
          Se asignarán
          <b class="font-lg"> {{ kilogramDiference._value }} Kg</b> a MERMA
        </p>
      </div>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            :disabled="loading === true"
            @click.prevent="
              (e) => {
                e.target.blur();
                onSubmitSquare();
              }
            "
            @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
            class="float-right ml-1"
            >Si
            <b-spinner v-if="loading" class="float-right" small />
          </b-button>
          <b-button class="float-right ml-1" @click="modalMerma = !modalMerma"
            >Cancelar</b-button
          >
        </div>
      </template>
    </b-modal>

    <b-modal
      title="Agregar detalles"
      @ok="submit"
      @cancel="cleanForm"
      @show="$v.$reset()"
      @shown="getProcessData"
      ref="modal"
      v-model="modalShown"
      :ok-disabled="remainingKilograms < 0"
      size="xl"
    >
      <b-row>
        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">Del producto</h4>
          <b-form-group label="Producto">
            <b-form-select
              id="product"
              @change="getProductSet"
              :disabled="disabledFields.product"
              :state="
                $v.contentData.product.$dirty
                  ? !$v.contentData.product.$error
                  : null
              "
              v-model="$v.contentData.product.$model"
              :options="products"
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Variedad" label-for="basicSelect">
            <b-form-select
              id="varietySelect"
              :disabled="disabledFields.variety"
              :state="
                $v.contentData.variety.$dirty
                  ? !$v.contentData.variety.$error
                  : null
              "
              v-model="$v.contentData.variety.$model"
              :options="productSet.varieties"
              value="Seleccione..."
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Condicion" label-for="basicSelect">
            <b-form-select
              id="conditionSelect"
              :disabled="disabledFields.condition"
              :state="
                $v.contentData.condition.$dirty
                  ? !$v.contentData.condition.$error
                  : null
              "
              v-model="$v.contentData.condition.$model"
              :options="conditions"
              value="Seleccione..."
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Huerto (CSG)" label-for="basicSelect">
            <b-form-select
              id="originSelect"
              v-model="contentData.origin"
              :options="origins"
              :disabled="disabledFields.origin"
              value="origins[0].value"
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Lote" label-for="basicSelect">
            <b-form-select
              id="LotSelect"
              v-model="contentData.lot"
              :options="lotOptions"
              value="lotOptions[0].value"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">Opciones</h4>

          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            description="Ingrese número de pallet. Deje en blanco si desea un numero automático."
            label-for="basicNumber"
          >
            <label for="example-input-group-1">
              Número de Pallet (Opcional)
              <a href="#"
                ><i
                  class="fa fa-question-circle text-info"
                  v-b-modal.modal-1
                ></i
              ></a>
            </label>

            <b-input-group>
              <b-form-input
                type="text"
                placeholder="123456789"
                :state="
                  $v.contentData.pallet_number.$dirty
                    ? !$v.contentData.pallet_number.$error
                    : null
                "
                v-model="$v.contentData.pallet_number.$model"
                :readonly="existing_pallet == true"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>#</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-modal size="sm" id="modal-1" title="Tip para numeros específicos">
            <p>
              Ingrese número de pallet. Deje en blanco si desea un numero
              automático.
              <b>Al usar esta función, evite repetir números.</b> Si quiere usar
              un pallet existente, utilice la función de más abajo.
            </p>
          </b-modal>

          <b-form-group label="Completar pallet" label-for="basicRadiosCustom2">
            <b-form-checkbox
              id="checkbox-2"
              v-model="existing_pallet"
              name="checkbox-2"
            >
              Pallet existente
            </b-form-checkbox>
          </b-form-group>

          <b-form-group v-if="contentData.interplanta">
            <label for=""
              >Tipo de envío (Opcional)
              <a href="#"
                ><i
                  class="fa fa-question-circle text-info"
                  v-b-modal.modal-2
                ></i
              ></a>
            </label>
            <b-form-radio
              v-model="contentData.pallet_type"
              name="some-radios"
              value="2"
              >Aéreo</b-form-radio
            >
            <b-form-radio
              v-model="contentData.pallet_type"
              name="some-radios"
              value="1"
              >Maritimo</b-form-radio
            >
          </b-form-group>
          <b-form-group label="Destino">
            <b-form-select
              v-model="contentData.destination"
              text-field="name"
              value-field="id"
              :options="destinations"
            >
            </b-form-select>
          </b-form-group>

          <b-modal
            size="sm"
            id="modal-2"
            title="Tip para protocolos de embalaje de pallets"
          >
            <p>
              Si usted tiene protocolos de embalaje de pallets, el sistema
              reconocerá cuando están completos según la cantidad de
              cajas/bultos que contiene. El protocolo depende de si el pallet es
              marítimo o aéreo. Para usar esta funcionalidad, pregunte a su
              administrador si ha creado los protocolos y asegúrese de elegir
              una de estas opciones.
            </p>
          </b-modal>

          <!--  <b-form-group
            label="Otros"
            label-for="basicCustomCheckboxes">
            <b-form-checkbox-group stacked id="basicCustomCheckboxes">
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk1"
                       value="gasificado">
                <label class="custom-control-label" for="customChk1">Gasificado</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk2"
                       value="a piso">
                <label class="custom-control-label" for="customChk2">A piso</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk3"
                       value="mallas">
                <label class="custom-control-label" for="customChk3">En mallas</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk4"
                       value="insectos">
                <label class="custom-control-label" for="customChk4">Presencia de insectos</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk5"
                       value="horario">
                <label class="custom-control-label" for="customChk5">Fuera de horario de recepcion</label>
              </div>
              <div class="custom-control custom-checkbox pb-1">
                <input type="checkbox" v-model="contentData.other" class="custom-control-input" id="customChk6"
                       value="iqf_campo">
                <label class="custom-control-label" for="customChk6">IQF de campo</label>
              </div>

            </b-form-checkbox-group>
          </b-form-group> -->
        </b-col>

        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">Del resultado</h4>

          <!--          TODO: Implement searchpallet-->

          <template v-if="existing_pallet === true">
            <b-form-group>
              <label for="">
                Pallet existente
                <a href="#"
                  ><i
                    class="fa fa-question-circle text-info"
                    v-b-modal.modal-3
                  ></i
                ></a>
              </label>
              <search-pallet @selected="existingPalletUpdate($event)">
              </search-pallet>
            </b-form-group>
          </template>

          <b-modal size="sm" id="modal-3" title="Tip para completar pallets">
            <p>
              Utilice esta funcion sólo si necesita completar pallets.
              <b
                >Si usted esta editando y desea que el pallet siga en su lugar,
                deje esto en blanco.
              </b>
            </p>
          </b-modal>

          <!--          Removed since complete stock pallet from processes was implemented-->

          <!--          <b-form-group-->
          <!--            v-if="existing_pallet===true"-->
          <!--            label="Pallet"-->
          <!--            label-for="palletSelect">-->
          <!--            <b-form-select id="palletSelect"-->
          <!--                           v-model="contentData.pallet"-->
          <!--                           value="Seleccione...">-->
          <!--                            <option-->
          <!--                              v-for="pallet in pallets"-->
          <!--                              v-bind:value="{ id: pallet.value, text: pallet.text }" >-->
          <!--                              {{ pallet.text }}-->
          <!--                              </option>-->
          <!--                          </b-form-select>-->
          <!--          </b-form-group>-->

          <b-form-group label="Tipo de producto" label-for="processTypeSelect">
            <b-form-select
              id="processTypeSelect"
              @change="changeTipoProducto($event)"
              :disabled="disabledFields.product_type"
              :state="
                $v.contentData.product_type.$dirty
                  ? !$v.contentData.product_type.$error
                  : null
              "
              v-model="$v.contentData.product_type.$model"
              value="Seleccione..."
            >
              <option
                v-for="product_type in productSet.product_types"
                v-bind:value="{
                  id: product_type.value,
                  text: product_type.text,
                  exportable: product_type.exportable
                }"
              >
                {{ product_type.text }}
              </option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Formato/Recipiente" label-for="containerSelect">
            <b-form-select
              id="containerSelect"
              :state="
                $v.contentData.container.$dirty
                  ? !$v.contentData.container.$error
                  : null
              "
              @change="getBulkSpecs($event.id)"
              v-model="$v.contentData.container.$model"
              :options="productSet.containers"
              value="Seleccione..."
            ></b-form-select>
          </b-form-group>

          <b-form-group
            v-if="contentData.interplanta === true"
            label="Planta de proceso (CSP)"
            label-for="plantSelect"
          >
            <b-form-select
              id="plantSelect"
              v-model="contentData.plant"
              :options="plants"
              :disabled="disabledFields.plant"
              value="Seleccione..."
            ></b-form-select>
          </b-form-group>

          <div
            v-if="
              contentData.interplanta === true && this.contentData.id === null
            "
          >
            <b-form-group
              v-for="(type, index) in productSet.spec_type"
              v-bind:label="type.name"
              :key="index"
              label-for="basicSelect"
            >
              <b-form-select
                id="specSelect"
                v-model="contentData.specifications[index]"
              >
                <option
                  v-for="spec in type.specs"
                  :key="spec.value"
                  v-bind:value="spec.value"
                >
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>

          <div
            v-if="
              productSet.spec_type_bulk.length > 0 &&
              contentData.interplanta === false
            "
          >
            <b-form-group
              v-for="(type, index) in productSet.spec_type_bulk"
              v-bind:label="type.name + ' (Opcional)'"
              :key="index"
              label-for="basicSelect"
            >
              <b-form-select
                id="specSelect"
                v-model="contentData.specifications[index]"
              >
                <option
                  v-for="spec in type.specs"
                  :key="spec.value"
                  v-bind:value="spec.value"
                >
                  {{ spec.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col lg="3">
          <h4 class="border-bottom border-info pb-2">De los números</h4>

          <b-form-group
            id="example-input-group-1"
            aria-describedby="input-1-live-feedback"
            label="Cantidad"
            label-for="basicNumber"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="Ingrese unidades resultantes"
                :state="
                  $v.contentData.quantity.$dirty
                    ? !$v.contentData.quantity.$error
                    : null
                "
                v-model="$v.contentData.quantity.$model"
              >
              </b-form-input>

              <b-input-group-append>
                <b-input-group-text>Un</b-input-group-text>
              </b-input-group-append>
              <b-form-invalid-feedback id="input-1-live-feedback">
                Este es un campo obligatorio. Ingrese un número entero positivo.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--          <b-form-group-->
          <!--            description="Los kilos que indica la pesa/romana."-->
          <!--            label="Kilos brutos (opcional)"-->
          <!--            label-for="basicNumber">-->
          <!--            <b-input-group>-->
          <!--              <b-form-input type="text"-->
          <!--                            placeholder="Ingrese kilos">-->
          <!--              </b-form-input>-->
          <!--              <b-input-group-append>-->
          <!--                <b-input-group-text>Kg</b-input-group-text>-->
          <!--              </b-input-group-append>-->
          <!--            </b-input-group>-->
          <!--          </b-form-group>-->

          <!--Kilos Netos-->
          <b-form-group
            label="Kilos netos"
            label-for="elementsAppend"
            description=""
          >
            <b-input-group>
              <!-- Attach Left button -->
              <!--              <b-input-group-prepend>-->
              <!--                <b-button variant="primary" @click="toggle">-->
              <!--                  <i class="fa fa-pencil"></i>-->
              <!--                </b-button>-->
              <!--              </b-input-group-prepend>-->
              <b-form-input
                type="text"
                v-if="netKilogramEdit === false"
                :state="
                  $v.contentData.net_kilograms.$dirty
                    ? !$v.contentData.net_kilograms.$error
                    : null
                "
                v-model="$v.contentData.net_kilograms.$model"
                :disabled="netKilogramEdit === true"
              >
              </b-form-input>
              <b-form-input
                type="text"
                v-if="netKilogramEdit"
                :value="calculateExport"
                :disabled="netKilogramEdit === true"
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <!--Sobrepeso-->
          <b-form-group label="Sobrepeso/DH">
            <b-input-group>
              <b-form-input
                placeholder="Ingrese kilos"
                :state="
                  $v.contentData.overweight.$dirty
                    ? !$v.contentData.overweight.$error
                    : null
                "
                v-model="$v.contentData.overweight.$model"
                :disabled="disabledOverweight"
              >
              </b-form-input>
              <!-- Attach Right button -->
              <b-input-group-append>
                <b-dropdown :text="overweightUnitText" variant="primary" right>
                  <b-dropdown-item @click="overweight_unit = true"
                    >Kg</b-dropdown-item
                  >
                  <b-dropdown-item @click="overweight_unit = false"
                    >%</b-dropdown-item
                  >
                </b-dropdown>
              </b-input-group-append>
            </b-input-group>
            <b-form-text id="inputLiveHelp">
              Considere <b>{{ kilogramDif ? kilogramDif : 0 }}</b> % de
              sobrepeso.
            </b-form-text>
          </b-form-group>

          <b-form-group
            label="Kilos netos + sobrepeso"
            label-for="basicInputDisabled"
          >
            <b-input-group>
              <b-form-input
                type="text"
                placeholder="En espera..."
                :value="calculateNet"
                disabled
              >
              </b-form-input>
              <b-input-group-append>
                <b-input-group-text>Kg</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <b-form-text>
              Considere <b>{{ remainingKilograms }}</b> Kilos restantes.
            </b-form-text>
          </b-form-group>
        </b-col>
      </b-row>
      <!--<div slot="modal-footer" class="w-100">-->
      <!--<p class="float-left"></p>-->
      <!--&lt;!&ndash; Same modal used to create and update content.  &ndash;&gt;-->
      <!--<b-button class="float-right" @click="submitPrueba" variant="primary">Guardar</b-button>-->
      <!--</div>-->
    </b-modal>
    <lot-modal :process_id="data.id"></lot-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { decimal, integer, minValue, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";
import { bus } from "../../main";
import searchPallet from "./../reusable/searchPallets.vue";
import LotModal from "./LotModal";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { log } from "util";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(miniToastr);

export default {
  name: "CreateContent",
  components: {
    searchPallet,
    LotModal
  },
  mounted() {
    this.$axios
      .get("/api/comex/destination_market/?no_page")
      .then((res) => {
        this.destinations = res.data;
      })
      .catch((error) => {
        console.log(error.response);
      });
  },
  props: {
    data: {
      type: Object,
      default: () => []
    },
    disabledFields: {
      type: Object,
      default: () => []
    },
    // products: {
    //   type: Array,
    //   default: () => []
    // },
    plants: {
      type: Array,
      default: () => []
    },
    origins: {
      type: Array,
      default: () => []
    },
    sumMarkedKilograms: {
      type: Object,
      default: () => []
    },
    sumNetKilograms: {
      type: Object,
      default: () => []
    },
    kilogramDiference: {
      type: Object,
      default: () => []
    }
  },
  data() {
    return {
      products: [],
      modalMerma: false,
      loading: false,
      net_kilogram_delta: 0, // used for calculate net on create and edit content cases
      modalShown: false,
      modalTitle: "Agregar detalles",
      newPallet: true,
      overweight_unit: false,
      netKilogramEdit: true,
      existing_pallet: false,
      contentData: {
        id: null,
        lot: null,
        pallet_number: "",
        destination: null,
        interplanta: false,
        product: "",
        variety: "",
        condition: "",
        origin: "",
        product_type: "",
        plant: "",
        pallet: null,
        pallet_type: null,
        creation_date: "",
        container: "",
        specifications: [],
        quantity: null,
        gross_kilograms: 0,
        net_kilograms: 0,
        overweight: null,
        origin_kilograms: "",
        other: [],
        client_customer: null
      },
      productSet: {
        product_types: [],
        containers: [],
        varieties: [],
        spec_type: [],
        spec_type_bulk: []
      },
      companyFacilities: [],
      pallets: [],
      destinations: [],
      conditions: [
        { value: "Orgánico", text: "Orgánico" },
        { value: "Convencional", text: "Convencional" },
        { value: "Org. System Approach", text: "Org. System Approach" }
      ],
      disabled_inputs: {
        origins: false,
        plants: false,
        newPallet: false
      },
      disabledOverweight: false
    };
  },
  mixins: [validationMixin],
  validations: {
    contentData: {
      product: { required },
      variety: { required },
      origin: { required },
      lot: { required },
      condition: { required },
      product_type: { required },
      pallet_number: {},
      plant: { required },
      container: { required },
      quantity: {
        required,
        integer,
        minValue: minValue(1)
      },
      overweight: {
        required,
        decimal,
        minValue: minValue(0)
      },
      net_kilograms: {
        required,
        decimal
      }
    }
  },
  computed: {
    autoNumber() {
      return (
        this.contentData.pallet_number === "" ||
        this.contentData.pallet_number === null
      );
    },
    lotOptions() {
      return this.$store.getters.groupedLots;
    },
    overweightUnitText() {
      return this.overweight_unit === true ? "Kg" : "%";
    },
    kilogramDif() {
      var num =
        parseFloat(this.overweight_kilograms / this.calculateExport) * 100;
      return num.toFixed(2);
    },
    calculateNet() {
      const num =
        parseFloat(this.calculateExport) +
        parseFloat(this.overweight_kilograms);
      return isNaN(num) ? "En espera..." : parseFloat(num).toFixed(2);
    },
    calculateExport() {
      const num =
        parseFloat(this.contentData.container.net_weight) *
          this.contentData.quantity || 0;
      return this.netKilogramEdit ? num : this.contentData.net_kilograms;
    },
    calculateNetDelta() {
      return this.calculateExport - this.net_kilogram_delta;
    },
    overweight_kilograms: function () {
      return this.overweight_unit === true
        ? parseFloat(this.contentData.overweight)
        : parseFloat(
            (this.contentData.overweight * this.calculateExport) / 100
          ).toFixed(2);
    },
    remainingKilograms() {
      if (this.contentData.id) {
        return (
          this.kilogramDiference.value() -
          this.calculateNetDelta -
          this.overweight_kilograms
        ).toFixed(2);
      } else {
        const num = this.kilogramDiference.value() - this.calculateNet;
        return isNaN(num)
          ? this.kilogramDiference.value().toFixed(2)
          : num.toFixed(2);
      }
    }
  },
  watch: {
    existing_pallet: {
      handler(val) {
        if (val == true) {
          this.contentData.pallet_number = "";
          this.getProcessPallets(this.data.id);
        }
      }
    },
    "contentData.product_type": {
      handler(val) {
        this.getProductContainers(val.exportable, this.contentData.product);
        this.netKilogramEdit = val.exportable;
      }
    }
  },
  created() {
    bus.$on("componentEditing", (data) => {
      // console.log(data.overweight_type+"aqui asd");

      this.getProcessPallets(this.data.id);
      this.existing_pallet = true;
      this.contentData.pallet_number = data.auto_number
        ? ""
        : data.pallet_number;
      this.contentData.id = data.id;
      this.contentData.lot = data.lot;
      this.contentData.destination = data.destination;
      this.contentData.interplanta = data.exportable;
      this.contentData.product = data.product;
      this.contentData.variety = data.variety;
      this.contentData.origin = data.origin;
      this.contentData.condition = data.condition;
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: data.exportable
      };
      this.contentData.plant = data.plant;
      this.contentData.pallet = { id: data.pallet, text: data.pallet_number };
      this.contentData.pallet_type = data.pallet_type;
      this.contentData.client_customer = data.client_customer;
      this.contentData.creation_date = data.creation_date;
      // this.getProductContainers(data.container.bulk, data.product);
      this.contentData.container = data.container;
      this.contentData.specifications = [];
      for (let key in data.specifications) {
        this.contentData.specifications.push(data.specifications[key].id);
      }
      this.disabled_inputs.newPallet = true;
      this.netKilogramEdit = data.exportable;
      this.contentData.overweight_type = data.overweight_type;
      (this.overweight_unit = data.overweight_type == 0 ? true : false),
        (this.contentData.net_kilograms = data.container.exportable
          ? 0
          : data.net_kilograms.value());
      this.net_kilogram_delta = data.net_kilograms.value();
      // this.contentData.overweight = data.exportable ? parseFloat(data.net_kilograms.value() - data.exportable_kilograms).toFixed(2) : 0;
      this.contentData.overweight = this.overweight_unit
        ? parseFloat(
            data.net_kilograms.value() - data.exportable_kilograms
          ).toFixed(2)
        : parseFloat(
            ((data.net_kilograms.value() - data.exportable_kilograms) /
              data.exportable_kilograms) *
              100
          ).toFixed(2);
      this.contentData.quantity = data.quantity;
      this.contentData.gross_kilograms = data.gross_kilograms;

      this.modalShown = true;

      if (this.products.length > 0) {
      } else {
        this.getProducts(this.data.client_customer);
      }

      this.changeTipoProducto(this.contentData.product_type);
    });
    bus.$on("createSimiliarInsidePallet", (data) => {
      this.getProcessPallets(this.data.id);
      this.existing_pallet = false;
      this.contentData.pallet_number = null;
      this.contentData.destination = data.destination;
      this.contentData.id = null;
      this.contentData.interplanta = data.exportable;
      this.contentData.product = data.product;
      this.contentData.lot = data.lot;
      this.contentData.variety = data.variety;
      this.contentData.condition = data.condition;
      this.contentData.origin = data.origin;
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: data.exportable
      };
      this.contentData.plant = data.plant;
      this.contentData.pallet = { id: data.pallet, text: data.pallet_number };
      this.contentData.pallet_type = data.pallet_type;
      this.contentData.client_customer = data.client_customer;
      this.contentData.creation_date = data.creation_date;
      this.contentData.container = data.container;
      this.contentData.specifications = [];
      for (let key in data.specifications) {
        this.contentData.specifications.push(data.specifications[key].id);
      }
      (this.overweight_unit = data.overweight_type == 0 ? true : false),
        (this.disabled_inputs.newPallet = true);
      this.netKilogramEdit = data.container.exportable;
      // this.contentData.net_kilograms = null;
      this.net_kilogram_delta = data.container.exportable
        ? 0
        : data.net_kilograms.value();
      this.contentData.overweight = null;
      this.contentData.quantity = null;
      this.contentData.gross_kilograms = 0;
      this.modalShown = true;

      if (this.products.length > 0) {
      } else {
        this.getProducts(this.data.client_customer);
      }
    });
  },
  methods: {
    createSupply(obj) {
      this.$axios({
        method: "POST",
        url: "/api/supplies/waybill-supply/process_supply/",
        data: {
          process_id: obj.contents[0].process_id,
          container_id: obj.contents[0].container,
          quantity: obj.contents[0].quantity,
          client_customer: obj.contents[0].client_customer,
          process_date: this.data.start_time,
          number_process: this.data.number
        }
      })
        .then((res) => {
          if (res.data.result == 1) {
            this.$emit("loadSupplyDetails");
            miniToastr.success("Materiales creados con éxito", "");
          }

          if (res.data.result == 3) {
            miniToastr.error(
              "se necesitan " +
                res.data.quantity_needy +
                " de " +
                res.data.supply +
                " y solo hay " +
                res.data.quantity_stock,
              "Imposible crear Materiales por falta de stock " +
                res.data.client_customer,
              6000
            );
          }

          if (res.data.result == 2) {
            miniToastr.error(
              "Imposible crear el Material formato no tiene ingresada la receta",
              ""
            );
          }
        })
        .catch((error) => {
          console.log("%o", error);
        });
    },
    openModalMerma() {
      if (Number(this.kilogramDiference._value) > 0) {
        this.modalMerma = true;
      } else {
        miniToastr.info("Proceso ya esta cuadrado", "");
      }
    },
    getProducts(client_customer) {
      this.$axios
        .get("/production/get_products_company/" + client_customer)
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }

          this.products = products;
        })
        .catch((error) => console.log(error));
    },
    onSubmitSquare() {
      this.loading = true;

      const palletData = {
        tipo: 1,
        number: "",
        auto_number: true,
        type: 2,
        contents: [
          {
            quantity: Number(0),
            net_kilograms: Number(this.kilogramDiference._value),
            origin_kilograms: Number(this.kilogramDiference._value),
            gross_kilograms: Number(this.kilogramDiference._value),
            origin: this.data.origin,
            condition: this.data.condition,
            product_type: "",
            pallet: "",
            type: "",
            lot: this.lotOptions[0].value,
            process_id: this.data.id,
            creation_date: moment(this.data.start_time).format("YYYY-MM-DD"),
            variety: this.data.variety,
            client_customer: this.data.client_customer,
            waybill: "",
            plant: this.data.plant.id,
            overweight_type: this.overweight_unit == true ? "0" : "1",
            container: "",
            specifications: this.contentData.specifications.filter(Boolean),
            classification: "",
            palletizing: ""
          }
        ]
      };

      var cantidad = Number(this.contentData.quantity);

      this.$axios
        .post("/api/v1/content/create_process_content_waste/", palletData)
        .then((res) => {
          if (res.data.status == 1) {
            this.traceabilityNewContent(
              res.data.content_id,
              this.data.id,
              cantidad
            );
            this.$emit("refresh", this.data.id);
            miniToastr.success("Operación realizada con éxito", "");

            this.$emit("validate", true);
            this.cleanForm();
          }

          if (res.data.status == 2) {
            miniToastr.error("Numero de pallet ingresado ya éxiste", "");
          }

          if (res.data.status == 3) {
            miniToastr.error(
              "No se encontro un tipo de producto creado con nombre MERMA de tipo Waste.(Debe crearlo)",
              ""
            );
          }

          if (res.data.status == 4) {
            miniToastr.error(
              "No se encontro un tipo de recipiente creado con nombre RMERMA de granel.(Debe crearlo)",
              ""
            );
          }

          this.loading = false;
          this.modalMerma = false;
        })
        .catch(function (error) {
          this.loading = false;
        });
    },
    getBulkSpecs(a) {
      this.$axios
        .get("/production/get_bulk_specs/" + a)
        .then((res) => {
          const data = res.data.spec_type;
          const specs = [];
          for (let key in data) {
            const spec = data[key];
            specs.push(spec);
          }
          this.productSet.spec_type_bulk = specs;
          // this.productSet.spec_type_bulk = res.data.spec_type;
        })
        .catch((error) => console.log(error));
    },

    existingPalletUpdate(data) {
      this.pallets.push({ text: data.number, value: data.id });
      this.contentData.pallet = { id: data.id, text: data.number };
    },

    cleanForm() {
      this.overweight_unit = false;
      this.contentData.pallet_number = "";
      this.contentData.destination = null;
      this.contentData.id = null;
      this.contentData.lot = null;
      this.contentData.interplanta = false;
      this.contentData.product = "";
      this.contentData.pallet_number = "";
      this.contentData.variety = "";
      this.contentData.condition = "";
      this.contentData.client_customer = "";
      this.contentData.origin = "";
      this.contentData.product_type = "";
      this.contentData.plant = "";
      this.contentData.pallet = "";
      this.contentData.pallet_type = "";
      this.contentData.creation_date = "";
      this.contentData.container = "";
      this.contentData.specifications = [];
      this.contentData.quantity = null;
      this.contentData.gross_kilograms = 0;
      this.contentData.net_kilograms = 0;
      this.contentData.overweight = null;
      this.contentData.origin_kilograms = "";
      this.contentData.other = [];
      this.disabled_inputs.newPallet = false;
    },
    getProcessData() {
      this.contentData.product = this.data.product;
      this.getProductSet(this.contentData.product);
      this.contentData.variety = this.data.variety;
      this.contentData.condition = this.data.condition;
      this.contentData.client_customer = this.data.client_customer;
      this.contentData.origin = this.data.origin;
      this.contentData.plant = this.data.plant;
      this.contentData.creation_date = this.data.start_time;
    },
    toggle() {
      this.contentData.net_kilograms = this.calculateExport;
      this.netKilogramEdit = !this.netKilogramEdit;
    },
    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.companyFacilities = res.data;
          this.contentData.plant = this.companyFacilities.plants[0].value;
          this.contentData.origin = this.companyFacilities.origins[0].value;
          this.contentData.lot = this.lotOptions[0].value;
          this.disabled_inputs.plants = false;
          this.disabled_inputs.origins = false;
        })
        .catch((error) => {
          this.disabled_inputs.plants = true;
        });
    },
    getProductContainers(exportable, product) {
      if (product == null) {
      } else {
        const url = exportable ? "std_company" : "bulk_company";
        this.$axios
          .get("/api/v1/container/" + product + "/" + url + "/", {
            params: {
              company: this.contentData.client_customer
            }
          })
          .then((res) => {
            this.productSet.containers = res.data;
          })
          .catch((error) => console.log(error.menssaje));
      }
      // if (product) {
      //   const url = exportable ? "std" : "bulk";
      //   this.$axios
      //     .get("/api/v1/container/" + product + "/" + url + "/")
      //     .then((res) => {
      //       this.productSet.containers = res.data;
      //     })
      //     .catch((error) => console.log(error));
      // }
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.productSet.spec_type = res.data.spec_type;
          this.productSet.varieties = res.data.varieties;
          this.productSet.product_types = res.data.product_types;
        })
        .catch((error) => console.log(error));
    },
    changeTipoProducto(obj) {
      if (obj.exportable == true) {
        this.contentData.interplanta = true;
        this.disabledOverweight = false;
        this.contentData.overweight = "";
      } else {
        this.contentData.specifications = [];
        this.contentData.interplanta = false;
        this.disabledOverweight = true;
        this.contentData.overweight = 0;
      }
    },

    // Validation methods
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    traceabilityNewContent(id_contenido, id_proceso, cantidad) {
      const formData = {
        id_content: id_contenido,
        process_id: id_proceso,
        quantity: cantidad,
        tipo: 2
      };

      axios
        .post("/api/v1/process/traceability_process/", formData)
        .then((res) => {
          //console.log(res)
        })
        .catch((error) => console.log(error.message));
    },
    traceabilityEditContent(id_contenido, id_proceso, cantidad) {
      const formData = {
        id_content: id_contenido,
        process_id: id_proceso,
        quantity: cantidad,
        tipo: 4
      };

      axios
        .post("/api/v1/process/traceability_process/", formData)
        .then((res) => {
          //console.log(res)
        })
        .catch((error) => console.log(error.message));
    },
    nuevoContenido() {
      this.modalShown = true;
      this.existing_pallet = false;

      this.contentData.pallet_number = "";
      this.contentData.id = null;
      this.contentData.lot = "";
      this.contentData.interplanta = false;
      this.contentData.product = "";
      this.contentData.variety = "";
      this.contentData.condition = "";
      this.contentData.client_customer = "";
      this.contentData.origin = "";
      this.contentData.product_type = "";
      this.contentData.plant = "";
      this.contentData.pallet = "";
      this.contentData.pallet_type = null;
      this.contentData.creation_date = "";
      this.contentData.container = "";
      this.contentData.specifications = [];
      this.contentData.quantity = null;
      this.contentData.gross_kilograms = 0;
      this.contentData.net_kilograms = 0;
      this.contentData.overweight = null;
      this.contentData.origin_kilograms = "";
      this.contentData.other = [];
      this.disabled_inputs.newPallet = false;

      if (this.products.length > 0) {
      } else {
        this.getProducts(this.data.client_customer);
      }
    },
    getProcessPallets(a) {
      if (a) {
        this.pallets = [];
        this.$axios
          .get("/api/v1/process/" + a + "/get_process_pallets/")
          .then((res) => {
            const data = res.data.data;
            for (let key in data) {
              let obj = { value: data[key].id, text: data[key].number };
              this.pallets.push(obj);
            }
          })
          .catch((error) => console.log(error.message));
      }
    },
    submit(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        // Create New Content Logic

        if (this.contentData.id === null) {
          if (this.existing_pallet == false) {
            this.modalShown = false;

            const palletData = {
              tipo: 1,
              number: this.contentData.pallet_number,
              destination: this.contentData.destination,
              auto_number: this.autoNumber,
              type: this.contentData.pallet_type,
              contents: [
                {
                  quantity: Number(this.contentData.quantity),
                  net_kilograms: Number(this.calculateNet),
                  origin_kilograms: Number(this.contentData.origin_kilograms),
                  gross_kilograms: Number(this.contentData.gross_kilograms),
                  origin: this.contentData.origin,
                  condition: this.contentData.condition,
                  product_type: this.contentData.product_type.id,
                  pallet: "",
                  type: "",
                  lot: this.contentData.lot,
                  process_id: this.data.id,
                  creation_date: moment(this.data.start_time).format(
                    "YYYY-MM-DD"
                  ),
                  variety: this.contentData.variety,
                  client_customer: this.contentData.client_customer,
                  waybill: "",
                  plant: this.contentData.plant.id,
                  overweight_type: this.overweight_unit == true ? "0" : "1",
                  container: this.contentData.container.id,
                  specifications: this.contentData.specifications.filter(
                    Boolean
                  ),
                  classification: "",
                  palletizing: ""
                }
              ]
            };

            var cantidad = Number(this.contentData.quantity);

            this.$axios
              .post("/api/v1/content/create_process_content/", palletData)
              .then((res) => {
                if (res.data.status == 1) {
                  this.createSupply(palletData);
                  this.traceabilityNewContent(
                    res.data.content_id,
                    this.data.id,
                    cantidad
                  );
                  this.$emit("refresh", this.data.id);
                  miniToastr.success("Operación realizada con éxito", "");

                  this.$emit("validate", true);
                  this.cleanForm();
                }

                if (res.data.status == 2) {
                  miniToastr.error("Numero de pallet ingresado ya éxiste", "");
                }
              })
              .catch((error) => console.log(error));
          }

          if (this.existing_pallet == true) {
            this.modalShown = false;

            const palletData = {
              tipo: 2,
              number: this.contentData.pallet_number,
              destination: this.contentData.destination,
              type: this.contentData.pallet_type,
              auto_number: this.autoNumber,
              contents: [
                {
                  quantity: Number(this.contentData.quantity),
                  net_kilograms: Number(this.calculateNet),
                  origin_kilograms: Number(this.contentData.origin_kilograms),
                  gross_kilograms: Number(this.contentData.gross_kilograms),
                  origin: this.contentData.origin,
                  condition: this.contentData.condition,
                  product_type: this.contentData.product_type.id,
                  pallet: this.contentData.pallet.id,
                  process_id: this.data.id,
                  lot: this.contentData.lot,
                  creation_date: moment(this.data.start_time).format(
                    "YYYY-MM-DD"
                  ),
                  variety: this.contentData.variety,
                  client_customer: this.contentData.client_customer,
                  waybill: "",
                  plant: this.contentData.plant.id,
                  overweight_type: this.overweight_unit == true ? "0" : "1",
                  container: this.contentData.container.id,
                  specifications: this.contentData.specifications.filter(
                    Boolean
                  ),
                  classification: "",
                  palletizing: ""
                }
              ]
            };

            var cantidad = Number(this.contentData.quantity);

            this.$axios
              .post("/api/v1/content/create_process_content/", palletData)
              .then((res) => {
                if (res.data.status == 1) {
                  this.createSupply(palletData);
                  this.traceabilityNewContent(
                    res.data.content_id,
                    this.data.id,
                    cantidad
                  );
                  this.$emit("refresh", this.data.id);
                  miniToastr.success("Operación realizada con éxito", "");

                  this.$emit("validate", true);
                  this.cleanForm();
                }

                if (res.data.status == 2) {
                  miniToastr.error("Numero de pallet ingresado ya éxiste", "");
                }
              })
              .catch((error) => console.log(error));
          }
        }
        // Update Content Logic
        else {
          this.modalShown = false;

          const palletData = {
            tipo: 2,
            number: this.contentData.pallet_number,
            destination: this.contentData.destination,
            auto_number: this.autoNumber,
            type: this.contentData.pallet_type,
            contents: [
              {
                id: this.contentData.id,
                quantity: Number(this.contentData.quantity),
                net_kilograms: Number(this.calculateNet),
                origin_kilograms: Number(this.contentData.origin_kilograms),
                gross_kilograms: Number(this.contentData.gross_kilograms),
                origin: this.contentData.origin,
                condition: this.contentData.condition,
                product_type: this.contentData.product_type.id,
                pallet: this.contentData.pallet.id,
                process_id: this.data.id,
                creation_date: moment(this.data.start_time).format(
                  "YYYY-MM-DD"
                ),
                variety: this.contentData.variety,
                client_customer: this.contentData.client_customer,
                waybill: "",
                lot: this.contentData.lot,
                plant: this.contentData.plant.id,
                overweight_type: this.overweight_unit == true ? "0" : "1",
                container: this.contentData.container.id,
                specifications: this.contentData.specifications.filter(Boolean),
                classification: "",
                palletizing: ""
              }
            ]
          };

          var cantidad = Number(this.contentData.quantity);

          this.$axios
            .put("/api/v1/content/update_process_content/", palletData)
            .then((res) => {
              this.traceabilityEditContent(
                res.data.content_id,
                this.data.id,
                cantidad
              );
              this.$emit("refresh", this.data.id);
            })
            .catch((error) => console.log(error));

          miniToastr.success("Operación realizada con exito", "");
          this.$emit("validate", true);
          this.cleanForm();
        }
      }
    }
  }
};
</script>

<style scoped></style>
